import React from 'react';
import { FileText, Shield, Clock, CheckCircle } from 'lucide-react';
import useSEO from '@/hooks/useSEO';

// Hidden DealerCenter Credit Application - not linked from site navigation
// This page is only accessible via direct link /credit-application2
const CreditApplicationPage2 = () => {
  useSEO('credit-application', 'Apply for Financing | We Have Your Car');

  return (
    <div className="min-h-screen bg-[#0a1628]">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#132238] to-[#1a4d8c]/30 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 font-['Exo_2']">
            <span className="gradient-text">Credit</span> Application
          </h1>
          <p className="text-xl text-[#a8b8d0] max-w-2xl">
            Apply for financing in minutes. We work with all credit types!
          </p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid md:grid-cols-4 gap-4 mb-8">
          <div className="bg-[#132238] rounded-lg p-4 flex items-center gap-3 border border-[#1a2d47]">
            <Clock className="text-[#ff6b35] shrink-0" size={24} />
            <div>
              <p className="text-white font-medium">Quick Approval</p>
              <p className="text-[#a8b8d0] text-sm">Get answers fast</p>
            </div>
          </div>
          <div className="bg-[#132238] rounded-lg p-4 flex items-center gap-3 border border-[#1a2d47]">
            <Shield className="text-[#ff6b35] shrink-0" size={24} />
            <div>
              <p className="text-white font-medium">Secure & Private</p>
              <p className="text-[#a8b8d0] text-sm">256-bit encryption</p>
            </div>
          </div>
          <div className="bg-[#132238] rounded-lg p-4 flex items-center gap-3 border border-[#1a2d47]">
            <CheckCircle className="text-[#ff6b35] shrink-0" size={24} />
            <div>
              <p className="text-white font-medium">All Credit Types</p>
              <p className="text-[#a8b8d0] text-sm">Everyone qualifies</p>
            </div>
          </div>
          <div className="bg-[#132238] rounded-lg p-4 flex items-center gap-3 border border-[#1a2d47]">
            <FileText className="text-[#ff6b35] shrink-0" size={24} />
            <div>
              <p className="text-white font-medium">No Obligation</p>
              <p className="text-[#a8b8d0] text-sm">Free to apply</p>
            </div>
          </div>
        </div>

        {/* DealerCenter Application Form (Hidden from menu) */}
        <div className="bg-[#132238] rounded-xl border border-[#1a2d47] overflow-hidden">
          <div className="p-2">
            <iframe 
              src="https://dwssecuredforms.dealercenter.net/CreditApplication/index/29005755?themecolor=8C8C8C&formtype=l&frameId=dws_frame_0&standalone=true&ls=Our Website"
              scrolling="auto"
              style={{ width: '100%', height: '1200px' }}
              frameBorder="0"
              title="DealerCenter Credit Application"
              data-testid="dealercenter-credit-iframe"
            />
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-6 text-center text-[#a8b8d0] text-sm">
          <p>
            By submitting this application, you authorize We Have Your Car to obtain your credit report 
            and contact you regarding your financing options.
          </p>
          <p className="mt-2">
            Questions? Call us at <a href="tel:5126660016" className="text-[#ff6b35] hover:underline">(512) 666-0016</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CreditApplicationPage2;
